import React from 'react'
import { Link } from 'react-router-dom'

// images
import Logo from '../../images/logo.jpeg' 

const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="blog" />
                                </div>
                               <p>
  YV Reddy Associates is a trusted architectural and interior contracting firm
  delivering high-quality corporate, commercial, and institutional projects
  with a strong focus on design excellence, functionality, and timely execution.
</p>

                                <div className="social-widget">
                                   <ul>
    <li>
        <a
            href="https://www.facebook.com/yvreddyassociate"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="ti-facebook"></i>
        </a>

        <a
            href="https://www.youtube.com/@yvreddyassociates774"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="ti-youtube"></i>
        </a>

        <a
            href="https://www.instagram.com/yv_reddy_associates"
            target="_blank"
            rel="noopener noreferrer"
        >
            <i className="ti-instagram"></i>
        </a>
    </li>
</ul>

                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Contact</h3>
                                </div>
                                <ul>
                                    <li>yvreddyassociates.com@gmail.com</li>
                                    <li>+91 7331149267</li>
                                    <li>THE RETREAT  Plots No. 68 and 69, Guttala Begumpet Village, Serilingampally Mandal, Madhapur, Ranga Reddy District, <br></br> Hyderabad - 500081</li>
                                    {/* <li> Madhapur</li> */}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Link</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">About Us</span> </Link></li>
                                    <li><Link onClick={ClickHandler} to="/services"><span className="rolling-text">Services</span> </Link></li>
                                    <li><Link onClick={ClickHandler} to="/projects"><span className="rolling-text">Projects</span></Link></li>
                                    <li><Link onClick={ClickHandler} to="/blog"><span className="rolling-text">Blogs</span> </Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact"><span className="rolling-text">Contact</span></Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-sm-12 col-12 scroll-text-animation" data-animation="fade_from_bottom">
                            <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>Newsletter</h3>
                                </div>
                                <form>
                                    <input type="email" className="input-fild" placeholder="Your Email..." />
                                        <button>Subscribe</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container-fluid">
                    <div className="row g-0">
                        <div className="col col-lg-6 col-12">
  <p className="copyright">
  © {new Date().getFullYear()} YV Reddy Associates. All Rights Reserved.
</p>

<p className="copyright">
  Designed & Developed by{" "}
  <a
    href="https://vmedianadvertising.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color: "inherit",
      textDecoration: "none",
      cursor: "pointer"
    }}
  >
    V Media & Advertising
  </a>
</p>

</div>
                        <div className="col col-lg-6 col-12">
                            <ul className="right">
                                <li><Link onClick={ClickHandler} to="/privace"><span className="rolling-text">Privacy Policy</span> </Link></li>
                                <li><Link onClick={ClickHandler} to="/terms"><span className="rolling-text">Terms & Conditions</span></Link></li>
                                {/* <li><Link onClick={ClickHandler} to="/about"><span className="rolling-text">About us</span></Link></li> */}
                                {/* <li><Link onClick={ClickHandler} to="/login"><span className="rolling-text">Login</span></Link></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;


